window.addEventListener("scroll", () => {
    whenScroll()
})
whenScroll()

setTimeout(() => {
    whenScroll()
}, 1000)

export function whenScroll() {
    try {
        let state = { notTop: false }

        if (window.scrollY > window.innerWidth * 0.1) {
            document.body.classList.add("notTop")
            if (!state.notTop) {
                state.notTop = true
                notTop()
            }
        } else {
            document.body.classList.remove("notTop")
            if (state.notTop) {
                state.notTop = false
                notTop()
            }
        }

        let spOffset = innerWidth > 1024 ? 0 : window.innerWidth * 0.3
        if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - document.querySelector(".footer__inner").getBoundingClientRect().height + spOffset) {
            document.body.classList.add("footer-see")
        } else {
            document.body.classList.remove("footer-see")
        }
    } catch (e) {
        console.error(e)
    }
}

function notTop() {
    document.body.classList.add("notTop-transition")
    setTimeout(() => {
        document.body.classList.remove("notTop-transition")
    }, 450)
}